<div class="duplicate-check-container">

  <div class="header">
    <div fiTranslation="ALT_TEXT_DUPLICATE_CHECK"></div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  <div class="main-container">

    <div class="main-content">
      <div class="dialog-field">
        <div class="check-description">
          @if (conflictContacts.length === 1) {
            <div fiTranslation="ACTION_DUPLICATE_CHECK_INTRO_CONTACT"></div>
          }
          @if (conflictContacts.length > 1) {
            <div  fiTranslation="ACTION_DUPLICATE_CHECK_INTRO_CONTACTS"></div>
          }
        </div>
        @if (isFinishedLoad) {
          <div class="check-container">
            <div class="existing-box box">
              <div class="check-title" fiTranslation="ACTION_DUPLICATE_CHECK_HEADER1"></div>
              @for (contacts of conflictContacts; track contacts; let count = $index) {
                <div class="contact-content existing" (click)="onSelectedContact(count)">
                  @if (contacts) {
                    <fi-duplicate-contact
                      [contactToDisplay]="contacts"
                      [leadData]="leadData"
                      [differenceKeys]="differenceKeys"
                      [existingContact]="true"
                      [contactEmptyCount]="exContactCount"
                      [addressEmptyCount]="exAddressCount"
                      [selected] = "selectedDuplicate"
                      [count] = "count"
                      [contentLength] ="conflictContacts.length"
                      [emails] = "[this.importedContact?.Email]"
                      >
                    </fi-duplicate-contact>
                  }
                  @if (selectedDuplicate === count) {
                    <div class="submit existing">
                      <div class="submit-container">
                        <div class="submit-btn" (click)="existingSubmit()">
                          <img src="/assets/icons/existing-contact.svg" alt="existing" class="icon" matTooltip="{{title}}"
                            matTooltipPosition="below" matTooltipClass='tooltip-style'>
                          <div class="text-container">
                            <div class="title" fiTranslation="BUTTON_DUPLICATE_USE_EXISTING_CONTACT1"></div>
                            <div class="subtitle" fiTranslation="BUTTON_DUPLICATE_USE_EXISTING_CONTACT2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if ((selectedDuplicate === conflictContacts.length - 1) && selectedDuplicate === count) {
                    <div class="additional-space"></div>
                  }
                  @if (selectedDuplicate === count) {
                    <div class="bottom-space"></div>
                  }
                </div>
              }
            </div>
            <div class="imported-box box">
              <div class="check-title" fiTranslation="ACTION_DUPLICATE_CHECK_HEADER2"></div>
              <div class="imported-cont">
                @for (array of conflictContacts; track array; let count = $index) {
                  <div class="contact-content imported" >
                    @if (importedContact) {
                      <fi-duplicate-contact
                        [contactToDisplay]="importedContact"
                        [leadData]="leadData"
                        [differenceKeys]="differenceKeys"
                        [contactEmptyCount]="imContactCount"
                        [addressEmptyCount]="imAddressCount"
                        [selected] = "selectedDuplicate"
                        [count] = "count"
                        [emails] = "[this.existingContact?.Email, this.existingContact?.AdditionalEmail]"
                        >
                      </fi-duplicate-contact>
                    }
                    <div [class.distance-space]="selectedDuplicate === count"></div>
                    @if (selectedDuplicate === count) {
                      <div class="submit" [class.is-disabled] = "selectedDuplicate > 0">
                        <div class="submit-container mail">
                          <div class="submit-btn" (click)="importedSubmit()">
                            <img src="/assets/icons/imported-contact.svg" alt="new-contact" class="icon"
                              matTooltip="{{title}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
                            <div class="text-container">
                              <div class="title" fiTranslation="BUTTON_DUPLICATE_USE_NEW_CONTACT1"></div>
                              <div class="subtitle" fiTranslation="BUTTON_DUPLICATE_USE_NEW_CONTACT2"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <div class="mail" [class.distance-space]="selectedDuplicate === count"></div>
                    @if (selectedDuplicate === count) {
                      <div class="submit" [class.is-disabled] = "selectedDuplicate > 0">
                        <div class="submit-container">
                          <div class="submit-btn" (click)="newMailSubmit()">
                            <img src="/assets/icons/imported-contact-new.svg" alt="save" class="icon" matTooltip="{{title}}"
                              matTooltipPosition="below" matTooltipClass='tooltip-style'>
                            <div class="text-container">
                              <div class="title" fiTranslation="BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT1"></div>
                              <div class="subtitle" fiTranslation="BUTTON_DUPLICATE_SAVE_ADDITIONAL_CONTACT2"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (selectedDuplicate === count && !(selectedDuplicate === conflictContacts.length - 1)) {
                      <div class="space"></div>
                    }
                    @if (selectedDuplicate === count) {
                      <div class="bottom-space"></div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }

      </div>

    </div>
  </div>

</div>

